import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { format } from 'date-fns';
import {
  SummaryTitle,
  SummaryContainer,
  CellLabel,
  CellValue,
  TableDivider,
} from '../css';
import {
  InvoiceCellText,
  InvoiceTable,
  InvoiceTableCell,
  ServiceAndPricingTable,
  ServiceDetailsContainer,
  ServiceDetailsTableCell,
} from './css';

const ServiceAndPricing = ({ data }) => {
  const renderPrice = (price) => {
    try {
      return price.value.toLocaleString('en-US', { style: 'currency', currency: price.currencyCode });
    } catch {
      return 'N/A';
    }
  };

  return (
    <SummaryContainer>
      <SummaryTitle>{t('ServiceAndPricing')}</SummaryTitle>

      <ServiceAndPricingTable>
        <ServiceDetailsContainer>
          <ServiceDetailsTableCell>
            <CellLabel>
              {t('ServiceLevel')}
              :
            </CellLabel>
            <CellValue>{data.serviceLevel}</CellValue>
          </ServiceDetailsTableCell>
          <ServiceDetailsTableCell>
            <CellLabel>
              {t('EstDelivery')}
              :
            </CellLabel>
            <CellValue>{format(data.estimatedDeliveryDate, t('DATE_FORMAT_PATTERN'))}</CellValue>
          </ServiceDetailsTableCell>
        </ServiceDetailsContainer>

        <InvoiceTable>
          {data.chargesPrice.value > 0
                        && (
                        <InvoiceTableCell>
                          <InvoiceCellText>{t('TotalCharges')}</InvoiceCellText>
                          <InvoiceCellText>{renderPrice(data.chargesPrice)}</InvoiceCellText>
                        </InvoiceTableCell>
                        )}
          {data.invoiceItems.map((item, index) => (
            item.amount.value > 0
                        && (
                        <InvoiceTableCell key={index}>
                          <InvoiceCellText>{item.description}</InvoiceCellText>
                          <InvoiceCellText>{renderPrice(item.amount)}</InvoiceCellText>
                        </InvoiceTableCell>
                        )
          ))}
          {data.taxPrice.value > 0
                        && (
                        <InvoiceTableCell>
                          <InvoiceCellText>{t('Tax')}</InvoiceCellText>
                          <InvoiceCellText>{renderPrice(data.taxPrice)}</InvoiceCellText>
                        </InvoiceTableCell>
                        )}
          <TableDivider />
          <InvoiceTableCell>
            <CellLabel>
              {t('TotalPrice')}
              :
            </CellLabel>
            <CellLabel>{renderPrice(data.totalPrice)}</CellLabel>
          </InvoiceTableCell>
        </InvoiceTable>

      </ServiceAndPricingTable>

    </SummaryContainer>
  );
};

ServiceAndPricing.propTypes = {
  data: PropTypes.shape({
    serviceLevel: PropTypes.string,
    estimatedDeliveryDate: PropTypes.string,
    chargesPrice: PropTypes.shape({
      value: PropTypes.number,
      currencyCode: PropTypes.string,
    }),
    invoiceItems: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        amount: PropTypes.shape({
          value: PropTypes.number,
          currencyCode: PropTypes.string,
        }),
      }),
    ),
    taxPrice: PropTypes.shape({
      value: PropTypes.number,
      currencyCode: PropTypes.string,
    }),
    totalPrice: PropTypes.shape({
      value: PropTypes.number,
      currencyCode: PropTypes.string,
    }),
  }),
};

export default ServiceAndPricing;
